<template>
  <!-- 积分商城-礼品列表 -->
  <div class="gift_list">
    <template v-if="createStep == 1">
      <div class="topbox" v-if="inputShow">
        <div>活动列表</div>
      </div>
      <!-- 头部表单查询 -->
      <jd-form
        ref="inputForm"
        v-if="inputShow"
        :formInfo="inputData"
        @search="searchForm"
      ></jd-form>
      <jd-form v-if="inputShow1" :formInfo="inputData1" @search="searchForm"></jd-form>
      <div v-if="statisType == 1" class="tabSwitch">
        <jdTab
          :tabsList="tabSwitchList"
          :fatherTabAct="currIndex"
          @change="handleTab"
        />
      </div>
      <div v-if="statisType == 1">
        <el-button style="width: auto;" @click="getphone()" v-preventReClick>批量导出兑换记录</el-button>
      </div>
      <!-- 表格内容 -->
      <jd-table
        :loading="talbeLoading"
        :tableData="tableData"
        style="width: 100%;margin-top: 12px;"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          noShow: false,
          total: totalNum,
        }"
        @handlePage="handlePages"
      >
        <el-table-column label="礼品名称" width="250">
          <template slot-scope="scope">
            <div class="activityName">
              <el-popover placement="top-start" width="500" trigger="hover">
                <p style="margin: 20px">
                  请用手机京东扫描下面二维码查看您店铺的活动详情
                </p>
                <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
                <!-- <div :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div> -->
                <qrcode-vue
                  class="qrcode"
                  :id="'qrcode' + scope.row.id"
                  :ref="'qrcode' + scope.row.id"
                  :size="qrcodeVue.size"
                  :value="scope.row.idUrl"
                  :logo="qrcodeVue.logo"
                  :bgColor="qrcodeVue.bgColor"
                  :fgColor="qrcodeVue.fgColor"
                  style="margin-left: 80px"
                ></qrcode-vue>
                <div>
                  <p style="margin: 20px">
                    链接地址：(手机京东店铺中活动详情链接地址)
                  </p>
                  <el-input v-model="scope.row.idUrl" style="margin: 0 20px; width: 220px"></el-input
                  ><el-button type="primary" v-clipboard:copy="scope.row.idUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
                    >复制</el-button
                  >
                  <el-button type="primary" @click="handleSrcImg(scope.row.id)">下载</el-button>
                </div>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/list_code.svg" alt="活动二维码" class="code" slot="reference" />
              </el-popover>
              <span>{{ scope.row.activityName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="礼品类型" prop="activityType">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.activityType == 9 ? "兑换实物" : "兑换优惠券" }}</span> -->
            <span>{{ scope.row.activityType | activityString }}</span>
          </template>
        </el-table-column>

        <el-table-column label="面值" prop="price">
          <!-- <template slot-scope="scope">
                </template> -->
        </el-table-column>

        <el-table-column label="所需积分" width="180">
          <template slot="header">
            <span>所需积分</span> &nbsp;
            <span class="open" v-show="!tableOpenAll" @click="tableOpenAll = true">展开全部</span>
            <span class="stop" v-show="tableOpenAll" @click="tableOpenAll = false">收起全部</span>
          </template>
          <template slot-scope="scope">
            <div v-show="!tableOpenAll">
              <span>
                {{ scope.row.memberLevelPointsListVOS[0].levelName }}:
                {{ scope.row.memberLevelPointsListVOS[0].point }}
              </span>
            </div>

            <div class="hoveTitleShowMore" v-show="tableOpenAll">
              <template v-for="item in scope.row.memberLevelPointsListVOS">
                <p v-if="item.allow" :key="item.level">{{ item.levelName }}：{{ item.point }}</p>
              </template>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="总数/已兑">
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span
            >/
            <span>{{ scope.row.sendNum }}</span>
          </template>
        </el-table-column>

        <el-table-column label="上下架时间" width="200">
          <template slot-scope="scope">
            <div class="activityTime">
              <span>上架: {{ scope.row.startTime }}</span>
              <span>下架: {{ scope.row.endTime }}</span>
              <span style="color: #7b61ff;">{{ scope.row.days }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最后修改时间" prop="updateTime" width="200"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1"> <i class="y1"></i>待上架 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>已上架 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已下架 </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="230">
          <template slot-scope="scope">
            <div class="editList">
              <span class="edit" v-if="scope.row.status == 1" v-zoom="{ from: pageName + '礼品列表', name: '编辑' }" @click="changeList(scope.row)"
                >编辑</span
              >
              <span class="edit" v-if="scope.row.status == 2 || scope.row.status == 3" @click="seeList(scope.row)">查看</span>
              <span class="edit" @click="seeList(scope.row,scope.row.activityType,true)">复制</span>
              <span class="count" v-if="scope.row.status == 1" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '上架' }"
                >上架</span
              >
              <span class="count" v-if="scope.row.status == 2" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '下架' }"
                >下架</span
              >
              <span class="count" @click="statisData(scope.row)">数据统计</span>
              <span class="delete" v-zoom="{ from: pageName + '礼品列表', name: '删除' }" @click="deleteById(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </jd-table>
    </template>
    <!-- 编辑弹窗 -->
    <el-dialog title="详情" :visible.sync="dialogFormVis" width="60%">
      <el-form :model="amendForm" label-width="120px">
        <el-form-item label="礼品名称:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="礼品名称:" v-if="theSta == 0">
          <el-input v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
        </el-form-item>
        <el-form-item label="添加优惠券:" v-if="couponTxt.couponId">
          <div>
            <div class="couponContent">
              <div class="txtNum">
                ￥
                <span style="font-size: 36px; color: #7B61FF">{{ couponTxt.discount }}</span>
              </div>
              <div class="txtSize">
                满 {{ couponTxt.quota }} 元可使用 <br />
                {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
              </div>
              <p class="time">有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}</p>
              <!-- <div class="background"></div>
                <div class="btn">
                  <el-button @click="createActivity" type="primary" size="small"
                    >取消</el-button
                  >
                </div> -->
            </div>
            <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
            <p class="pContent">发行量：{{ couponTxt.num }}</p>
            <br />
            <p class="pContent">领券开始时间：{{ couponTxt.tekeBeginTime }}</p>
            <p class="pContent">领券结束时间：{{ couponTxt.takeEndTime }}</p>
            <br />
            <p class="pContent">限领规则：{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</p>
          </div>
        </el-form-item>
        <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9">
          <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input>&nbsp;元
        </el-form-item>
        <el-form-item label="礼品图片:" v-if="amendForm.activityType != 10">
          <img :src="amendForm.logo" style="width: 146px; height: 146px" />
          <p style="color: #7B61FF; font-size: 12px">
            建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG
          </p>
        </el-form-item>
        <el-form-item label="活动类型:">
          <el-radio-group v-model="amendForm.activityType" disabled>
            <el-radio :label="9">积分兑换实物</el-radio>
            <el-radio :label="10">积分兑换优惠券</el-radio>
            <el-radio :label="29">积分兑换京豆</el-radio>
            <el-radio :label="30">积分兑换E卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9 || amendForm.activityType == 10">
          <el-input v-model="amendForm.price" style="width: 180px" disabled></el-input>
          元
        </el-form-item>
        <el-form-item label="上下架时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.startTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
            <span> 至 </span>
            <el-date-picker
              disabled
              v-model="amendForm.endTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
          <span class="lastTime">
            活动持续
            <span style="color: #7B61FF">{{ timeDay }}</span> 天
          </span>
        </el-form-item>
        <el-form-item label="最后修改时间:">
          <div class="my_select_time">
            <el-date-picker
              disabled
              v-model="amendForm.updateTime"
              type="datetime"
              size="small"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 180px; font-size: 12px"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="京豆套餐:" v-if="amendForm.activityType == 29 && amendForm.exchangeType == 1">
          <el-table
            :data="amendForm.exchangeSet"
            border
            style="width: 542px; border: 1px solid #f0f0f0"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="singleNum" label="单个套餐京豆数量（个）">
              <template slot-scope="scope">
                <el-input v-model="scope.row.singleNum" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="套餐数量（个）">
              <template slot-scope="scope">
                <el-input v-model="scope.row.total" disabled></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="次数限制:" v-if="amendForm.activityType == 29">
          <el-radio-group v-model="amendForm.ruleType" disabled>
            <el-radio :label="1">每人每日兑换次数</el-radio>
            <el-radio :label="2">每人活动内兑换次数</el-radio>
          </el-radio-group>
          <div>
            <el-input v-model="amendForm.limitVal" disabled placeholder="请输入" style="width: 120px"></el-input>
            次（最多20次）
          </div>
        </el-form-item>
        <el-form-item label="每人限兑次数:" v-if="(amendForm.activityType == 9 ) || amendForm.activityType == 10">
          <div class="limitBox">
            <el-input disabled v-model="amendForm.exchangeTimes" style="width: 180px"></el-input>
            次
            <p class="desc">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder1.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px 4px 0 3px;
                "
              />
              不填则默认不限
            </p>
          </div>
        </el-form-item>
        <el-form-item :label="amendForm.activityType == 30 ? '兑换次数限制:' : '数量限制:'" v-else-if="amendForm.activityType != 9">
          <span> 活动期间每人每天最多可兑换</span>
          <el-input v-model="amendForm.exchangeDayNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
          <span>次，累计每人最多可兑换</span>
          <el-input v-model="amendForm.exchangeNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
          <span>次</span>
        </el-form-item>
        <el-form-item label="选择E卡:" v-if="amendForm.activityType == 30">
          <el-select v-model="amendForm.itemId" placeholder="请选择" disabled>
            <el-option label="1元" value="2"></el-option>
            <el-option label="5元" value="3"></el-option>
            <el-option label="20元" value="4"></el-option>
            <el-option label="50元" value="5"></el-option>
            <el-option label="100元" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="amendForm.activityType == 29 || amendForm.activityType == 30 ? '发放总量' : '总份数:'">
          <el-input disabled v-model="amendForm.quantityTotal" show-word-limit style="width: 136px"></el-input>&nbsp;
          {{ amendForm.activityType == 29 ? "个" : amendForm.activityType == 30 ? "张" : "份" }}
        </el-form-item>
        <el-form-item label="兑换所需积分:">
          <div class="isLevelSet">
            <template>
              <ul class="levelList" v-for="(item, index) in memberLevelList" :key="index">
                <li class="item" v-if="item.allow == true" style="width: 240px">
                  {{ item.name }}
                  <el-input disabled v-model="item.point" placeholder="请输入..." style="width: 80px"></el-input>
                  积分
                </li>
                <br />
              </ul>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 1">
          <el-input disabled v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="规则说明:" v-if="theSta == 0">
          <el-input v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="theSta == 0">
        <el-button @click="dialogFormVis = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisB">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input disabled placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCodeInit">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="savePhone()">
          确定
        </button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 数据统计 -->
    <statistics v-if="createStep == 3" @returnStep="returnStep" :rowData="rowData" :ids1="ids1"></statistics>
    <!-- 积分活动 -->
    <create-coupons
      ref="createStep13"
      :isShow="createStep == 13"
      v-if="createStep == 13"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      @return="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons>
    <create-coupons2
      ref="createStep14"
      :isShow="createStep == 14"
      v-if="createStep == 14"
      :tabActive="activityData.activityType"
      :activityData="activityData"
      @returnback="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons2>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "@/components/jhk/inputForm";
import { prefixurl } from "@/api/jhk/paradiseAndTaskCommonController.js";
import qrcodeVue from "qrcode-vue";
import {
  exchangeActivityList,
  deleteActivityList,
  updateActivityList,
  inquireActivity,
  changeActivity,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statistics from "./activity_data_statistics.vue";
import { querydetail } from "@/api/jhk/integralCenter/couponWriteController.js";
import { getmoble, getSellerCheckCode, exportBatch } from "@/api/jhk/paradiseAndTaskCommonController.js";
import createCoupons from "./create_coupons.vue";
import createCoupons2 from "./create_coupons2.vue";

export default {
  props: {
    inputShow: {
      default: true,
    },
    inputShow1: {
      default: false,
    },
    activityType: {
      default: "",
    },
    statisType: {
      default: 1,
    },
    top: {
      default: false
    }
  },
  components: {
    inputForm,
    qrcodeVue,
    statistics,
    createCoupons,
    createCoupons2,
  },
  data() {
    return {
      tabSwitchList: [{
        title: "全部",
        tabKey: '0'
      },{
        title: "已上架",
        tabKey: '1'
      },{
        title: "待上架",
        tabKey: '2'
      },{
        title: "已下架",
        tabKey: '3'
      }],
      currIndex: 0,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,
      //
      rowData: {},
      ids1: "",
      createStep: 1,
      qrcodeVue: {
        size: 260,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/new-images/jd_logo.svg"), //logo图片
      },
      pageName: "忠诚度管理-积分商城",
      memberLevelList: [
        { value: "非会员", label: 0, point: "" },
        { value: "一星会员", label: 1, point: "" },
        { value: "二星会员", label: 2, point: "" },
        { value: "三星会员", label: 3, point: "" },
        { value: "四星会员", label: 4, point: "" },
        { value: "五星会员", label: 5, point: "" },
      ],
      talbeLoading: false,
      outerVisible: false,
      timeDay: 0, //活动持续天数
      theSta: 0,
      dialogFormVis: false,
      amendForm: {},
      couponTxt: {},
      // 表单配置项
      inputData: [
        {
          label: "礼品名称：",
          prop: "activityName",
          type: "Input",
          value: "",
          placeholder: "请填入活动名称",
        },
        {
          label: "礼品类型",
          prop: "activityType",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "兑换优惠券", value: 10 },
            { label: "兑换实物", value: 9 },
            { label: "兑换京豆", value: 29 },
            { label: "兑换E卡", value: 30 },
          ],
        },
        {
          label: "上架状态",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待上架", value: 1 },
            { label: "已上架", value: 2 },
            { label: "已下架", value: 3 },
          ],
        },
      ],
      inputData1: [
        {
          label: "礼品名称：",
          prop: "activityName",
          type: "Input",
          value: "",
          placeholder: "请填入活动名称",
        },
        {
          label: "上架状态",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: ""},
            { label: "待上架", value: 1 },
            { label: "已上架", value: 2 },
            { label: "已下架", value: 3 },
          ],
        },
      ],
      // 表格数据
      tableData: [],
      // 所需积分内容展开
      tableOpenAll: false,
      totalNum: 0,
      formList: {
        current: 1,
        size: 10,
      },
      status: 0,
      ids: null,
      qrcode: null,
      venderType: 0,
      activityData: {},
    };
  },
  filters: {
    activityString(key) {
      let obj = {
        9: "兑换实物",
        10: "兑换优惠券",
        29: "兑换京豆",
        30: "兑换E卡",
      };
      return obj[key];
    },
  },
  created() {
    this.prefixQue();
    getmoble().then((res)=>{
      this.venderType = res.data.venderType
    })
  },
  mounted() {
    this.getChangeList();
  },
  methods: {
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) this.formList.status = "";
      if (i == 1) this.formList.status = 2;
      if (i == 2) this.formList.status = 1;
      if (i == 3) this.formList.status = 3;
      this.inputData[2].value = this.formList.status;
      this.$refs["inputForm"].reData();
      this.getChangeList();
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    savePhone() {
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      // let params = {
      //   code: this.code,
      //   endTime: this.formList.endTime,
      //   startTime: this.formList.startTime,
      //   activityId: this.formList.activityId,
      // };
      exportBatch({ ...this.formList, code: this.code }).then((res) => {
        if (res.code == 1) {
          var blob = new Blob([res.blob]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "互动商城.xls";
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.visible = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    async getphone() {
      this.code = "";
      const { data: res } = await getmoble();
      this.visible = true;
      this.phone = res.mobile;
      this.countdown = 60;
      this.codeDisabled = false;
      this.codeMsg = "获取验证码"; // 按钮上的文字
      this.venderType = res.venderType
      clearInterval(this.timer);
      this.timer = null;
      this.venderType = res.venderType
      // console.log(this.formDataList, 9999);
    },
    returnStep() {
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
    },
    returnStep1(){
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
      this.$emit("handleshow", true);
    },
    handleSrcImg(id) {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    searchClick(val) {
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.formLis.current = 1;
      this.getChangeList();
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.getChangeList();
    },
    //获取列表数据
    getChangeList() {
      this.talbeLoading = true;
      if (this.inputShow1) this.formList.activityType = this.activityType;
      exchangeActivityList(this.formList).then((res) => {
        this.tableData.forEach((item, index) => {
          var ref = "qrcode" + item.id;
          // console.log( this.$refs[ref])
          this.$nextTick(() => {
            this.$refs[ref].innerHTML = "";
          });
        });
        this.talbeLoading = false;
        this.tableData = res.data.records.map((item) => {
          return {
            ...item,
            days: this.DayHours(item.startTime, item.endTime, item.status),
          };
        });
        this.totalNum = Number(res.data.total);
        this.prefixQue();
        // console.log(res.data, 222222);
        let mesUrl = "";
        this.tableData.forEach((item) => {
          // if (item.activityType == 9) {
          //   mesUrl = "integralStore_exchange";
          // } else if (item.activityType == 10) {
          //   mesUrl = "integralStore_discount";
          // }
          // item.idUrl = this.activityUrl + "/" + mesUrl + "?id=" + item.id + "&venderId=" + this.venderId;

          let xcxUrl = this.$commonUrl(); // 正式
          let options = {
            activityId: item.id,
            venderId: this.venderId,
            activityType: item.activityType || item.type,
            id: item.id,
          };
          let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%7D`;
          if (item.activityType == 9) {
            item.idUrl = xcxUrl + "pages/integralStore/exchange/exchange.html%3fitem%3d" + params1;
          }
          if (item.activityType == 10) {
            item.idUrl = xcxUrl + "pages/integralStore/discount/discount.html%3fitem%3d" + params1;
          }
          //  京豆、e卡
          if (item.activityType == 29 || item.activityType == 30) {
            item.idUrl = xcxUrl + "pages/integralStore/conversionDou/conversionDou.html%3fitem%3d" + params1;
          }

          // this.$nextTick(() => {
          //   let queryId = "qrcode" + item.id;
          //   this.qrcodeAll(item.idUrl, queryId);
          // });
        });
        // console.log(this.tableData, 222222);
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.amendForm.startTime.substring(0, 10);
      daysEnd = this.amendForm.endTime.substring(0, 10);
      if (this.amendForm.endTime != "" && this.amendForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.amendForm.endTime).getTime() - new Date(this.amendForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 表单查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.current = 1;
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.getChangeList();
    },
    //修改
    changeList(row) {
      this.theSta = 0;
      this.dialogFormVis = true;
      let id = row.id;
      inquireActivity(id)
        .then((res) => {
          this.amendForm = res.data;
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }

          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10 && this.venderType == 0) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
        })
        .catch((res) => {});
    },
    //修改确定
    dialogFormVisB() {
      this.dialogFormVis = false;
      let obj = {
        activityName: this.amendForm.activityName,
        activityType: Number(this.amendForm.activityType),
        id: Number(this.amendForm.id),
        ruleDescription: this.amendForm.ruleDescription,
      };
      // console.log(row,111);
      // console.log(obj, 222);
      changeActivity(obj)
        .then((res) => {
          if (res && res.id) {
            this.getChangeList();
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
        })
        .catch((res) => {});
    },
    //查看
    seeList(row,type,copy = false) {
      this.theSta = 1;
      let id = row.id;
      inquireActivity(id)
        .then((res) => {
          console.log(res.data);
          this.amendForm = res.data;
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }
          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10 && this.venderType == 0) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
          if(copy){
            this.activityData = {...this.amendForm}
            if(type == 10 || type == 9){
              this.createStep = 13
            }else if(type == 29 || type == 30){
              this.createStep = 14
            }
            this.$emit("handleshow", false);
          }else{
            this.dialogFormVis = true;
          }
        })
        .catch((res) => {});
    },
    // 数据统计
    statisData(row) {
      if (this.statisType == 1) {
        this.rowData = row;
        this.ids1 = row.id;
        this.createStep = 3;
      } else {
        this.$emit("statisDataCreate", row);
      }
    },

    amendTheList() {},
    //删除
    deleteById(row) {
      this.ids = Number(row.id);
      this.outerVisible = true;
    },
    handleDeleteTable() {
      let id = this.ids;
      deleteActivityList(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
          this.outerVisible = false;
        })
        .catch((res) => {});
    },
    //上下架
    updateList(row) {
      if (row.status == 1) {
        this.status = 2;
      } else if (row.status == 2) {
        this.status = 3;
      }
      let list = {
        id: Number(row.id),
        status: Number(this.status),
      };
      console.log(list);
      updateActivityList(list)
        .then((res) => {
          console.log(res);
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          // console.log(res, "res");
          // this.$message.error(res.message);
        });
    },
    DayHours(start, end, status) {
      // let startTime = new Date(start);
      // let endTime = new Date(end);
      let nowTime = this.formatDate(new Date());
      let res = "";
      // 未开始
      if (status == 1) {
        let arr = this.timediff(start, nowTime);
        res = arr[0] + "天" + arr[1] + "小时" + arr[2] + "分后开始";
      }
      // 进行中
      if (status == 2) {
        let arr = this.timediff(start, nowTime);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      // 已结束
      if (status == 3) {
        let arr = this.timediff(start, end);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      return res;
    },
    timediff(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      // var res = days + "天" + hours + "小时" + mins + "分";
      return [days, hours, mins];
    },
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1, //月份
        "d+": currentDate.getDate(), //日
        "h+": currentDate.getHours(), //小时
        "m+": currentDate.getMinutes(), //分
        "s+": currentDate.getSeconds(), //秒
        "q+": Math.floor((currentDate.getMonth() + 3) / 3), //季度
        S: currentDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      return fmt;
    },
    // 分页事件
    handlePages(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getChangeList();
    }
  },
};
</script>

<style scoped lang="scss">
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
  &:active {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #7b61ff;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.tabSwitch {
  margin-top: 12px;
  display: flex;
  color: #666;
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.gift_list {
  box-sizing: border-box;
  background: #fff;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .pContent {
    // display: block;
    float: left;
    width: 250px;
    color: #999999;
  }
  .couponContent {
    height: 130px;
    width: 260px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    position: relative;
    .txtNum {
      position: absolute;
      margin: 25px;
      width: 160px;
    }
    .txtSize {
      margin: 20px 0 0 140px;
    }
    .time {
      font-size: 12px;
      margin-left: 30px;
      color: #999999;
    }
    .btn {
      display: none;
      opacity: 0;
    }
  }
  .isLevelSet {
    // display: flex;
    .levelList {
      display: flex;
      flex-wrap: wrap;
      width: 450px;
      .item {
        text-align: right;
        margin-bottom: 16px;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .limitBox {
    .desc {
      font-size: 13px;
      color: #999;
      i {
        color: #fe8f8a;
        opacity: 0.8;
      }
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .open,
  .stop {
    color: #7b61ff;
    cursor: pointer;
  }
  .tooltip {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    width: 90%;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #7b61ff;
      }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #7b61ff;
      }
    }
  }
  .y1,
  .y2,
  .y3 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #cccccc;
  }
  .y2 {
    background-color: #7f85e9;
  }
  .y3 {
    background-color: #7b61ff;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
      &:active {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
    }
    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #7b61ff;
      color: #ffffff;
      border-radius: 3px;
      background-color: #7b61ff;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #7b61ff;
      }
      &:active {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
    }
  }
}
</style>
